import { useCallback } from "react";
import { IOpenPanel } from "../../../../../../Interfaces/IPanel";
import { IUbicacionEdit } from "../../../../../../Interfaces/auxiliar/IUbicacion";
import { PanelDrawer } from "../../../../../../components/Panel/PanelDrawer";
import { UsePaneUbicacionEditar } from "./UsePanelUbicacionEditar";
import { PanelFooter } from "../../../../../../components/Panel/PanelFooter";
import { Panel, TextField } from "@fluentui/react";
import { PanelHeader } from "../../../../../../components/Panel/PanelHeader";
import { MessageBarResponse } from "../../../../../../components/MessageBarResponse/MessageBarResponse";
import { ProgressBarLoading } from "../../../../../../components/ProgressBarLoading/ProgressBarLoading";

export interface IPanelUbicacionEditar extends IOpenPanel {
  item: IUbicacionEdit;
}

export const PanelEditarUbicacion = (props: IPanelUbicacionEditar) => {
  const { request, setRequest, putEditarUbicacion, loading, reset, mensaje, status } = UsePaneUbicacionEditar(props);

  const obtenerTextoEncabezado = (nivel?: number, descripcion?: string) => {
    switch (nivel) {
      case 1:
        return "Tajo";
      case 2:
        return "Región";
      case 3:
        return "Ubicación";
      default:
        return descripcion === "ubicacion" ? "Ubicación" : "";
    }
  };

  const onRenderHeader = useCallback(
    () => {
      const headerText = obtenerTextoEncabezado(props.item.nivel);
      return (
        <PanelHeader
          textHeader={`Editar ${headerText}`}
        />
      );
    },
    [props.item.nivel]

  );

  const onRenderFooter = useCallback(
    () => (
      <>
        <PanelFooter
          texto="Editar"
          texto2={"Salir"}
          onClick={putEditarUbicacion}
          onDismiss={() => {
            reset();
          }}
        />
      </>
    ),
    [request]
  );

  return (
    <Panel
      isOpen={props.isOpen}
      onDismiss={reset}
      onRenderHeader={onRenderHeader}
      isFooterAtBottom
      onRenderFooter={onRenderFooter}
    >
      <div className="ms-Grid" dir="ltr">
        <div hidden={mensaje == ""}>
          <MessageBarResponse
            objetoResponse={{ codigo: status, mensaje: mensaje }}
            close={true}
          />
        </div>
        <div hidden={!loading}>
          <ProgressBarLoading></ProgressBarLoading>
        </div>
        <div className="ms-Grid-row" hidden={loading}>
          {!mensaje && (
            <>

              <TextField
                type="text"
                label={`Nombre de  ${obtenerTextoEncabezado(props.item.nivel)}`}
                placeholder="Ingrese Nombre de Ubicacion"
                autoComplete="off"
                value={request.nombre}
                onChange={(event, newValue) => {
                  if (newValue != null) {
                    setRequest({ ...request, nombre: newValue });
                  }
                }}
              />
              <br />
              <TextField
                type="text"
                label={`Codigo de  ${obtenerTextoEncabezado(props.item.nivel)}`}
                placeholder="Ingrese Código de Ubicación"
                autoComplete="off"
                value={request.codigo}
                onChange={(event, newValue) => {
                  if (newValue != null) {
                    setRequest({ ...request, codigo: newValue });
                  }
                }}
              />
              <br />
              <TextField
                type="number"
                label={`Nivel de  ${obtenerTextoEncabezado(props.item.nivel)}`}
                placeholder="Ingrese Nivel de Ubicación"
                autoComplete="off"
                value={request.nivel?.toString()}
                onChange={(event, newValue) => {
                  if (newValue != null) {
                    setRequest({ ...request, nivel: parseInt(newValue) });
                  }
                }}
                disabled
              />
              <br />
            </>
          )}
        </div>
      </div>
    </Panel >
  );
};

